function EMAEnrolleeStatus() {
    "use strict";

    this.__type = 'EMAEnrolleeStatus:www.veritracks.com';
    this.Id = "";
    this.HasEnrolleeMobileApp = 0;
    this.CellPhoneNumber = "";
    this.AppUserId = "";
    this.EMAFlag = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = EMAEnrolleeStatus;
}